var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3425_5419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 41.7578C18.6644 41.7578 18.3315 41.6274 18.0738 41.3694L6.97315 30.1374C0.342282 23.4281 0.342282 12.5086 6.97315 5.79929C10.1866 2.54786 14.4577 0.757812 19 0.757812C23.5423 0.757812 27.8134 2.54786 31.0268 5.79929C37.6577 12.5086 37.6577 23.4254 31.0268 30.1374L19.9262 41.3694C19.6711 41.6274 19.3356 41.7578 19 41.7578Z",
    fill: "#F5BE49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 41.7578C18.6644 41.7578 18.3315 41.6274 18.0738 41.3694L6.97315 30.1374C0.342282 23.4281 0.342282 12.5086 6.97315 5.79929C10.1866 2.54786 14.4577 0.757812 19 0.757812C23.5423 0.757812 27.8134 2.54786 31.0268 5.79929C37.6577 12.5086 37.6577 23.4254 31.0268 30.1374L19.9262 41.3694C19.6711 41.6274 19.3356 41.7578 19 41.7578Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3425_5419",
    x: 0.5,
    y: 0.257812,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3425_5419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3425_5419",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerYellow);
export default __webpack_public_path__ + "static/media/marker_yellow.99c887393a6b4f8e40504761287c1112.svg";
export { ForwardRef as ReactComponent };